import { render, staticRenderFns } from "./LampiranPengawalanView.vue?vue&type=template&id=0d752a2e&scoped=true&lang=pug&"
import script from "./LampiranPengawalanView.vue?vue&type=script&lang=js&"
export * from "./LampiranPengawalanView.vue?vue&type=script&lang=js&"
import style0 from "./LampiranPengawalanView.vue?vue&type=style&index=0&id=0d752a2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d752a2e",
  null
  
)

export default component.exports